import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import EntityTable from "../../common/tables/EntityTable";
import { EntityFieldTypes } from "@emberly/zenith-client";
import ResponsivePage from "../../common/core/ResponsivePage";
import { Grid, Typography } from "@mui/material";
import config from "../../../config";
import { useNavigate } from "react-router";
import { MissionFormEnumsLists } from "../../../common/constants";
import { FullTimeView } from "../../common/core/Time";
import { useDevice } from "../../../providers/DeviceProvider";

export default function MissionFormRegister() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { slim } = useDevice();

  const columns = useMemo(() => {
    return [
      {
        field: "name",
        headerName: t("missionFormRegister:fieldName"),
        flex: 1,
        minWidth: 120,
      },
      {
        field: "formType",
        headerName: t("missionFormRegister:fieldType"),
        flex: 1,
        minWidth: 120,
        type: "singleSelect",
        valueGetter: (_, row) => row.formType,
        valueFormatter: (value) => t(`missionForm:enums:formType:${MissionFormEnumsLists.FormType[value]}`),
        valueOptions: MissionFormEnumsLists.FormType.map((_, value) => ({
          value,
          label: t(`mission:enums:fuelType:${MissionFormEnumsLists.FormType[value]}`),
        })).filter(t => !!t.label)
      },
      {
        field: "customer",
        headerName: t("missionFormRegister:fieldCustomer"),
        valueGetter: (_, row) => row.customer?.name || "-",
        flex: 1,
        minWidth: 120,
      },
      {
        field: "lastSubmit",
        headerName: t("missionFormRegister:fieldLastSubmit"),
        type: "dateTime",
        valueGetter: (_, row) => !!row?.lastSubmit ? new Date(row.lastSubmit) : null,
        renderCell: (params) => !!params.row.lastSubmit ? <FullTimeView time={params.row.lastSubmit} /> : "-",
        flex: 1,
        minWidth: 120,
      },
      {
        field: "submitCount",
        headerName: t("missionFormRegister:fieldSubmitCount"),
        valueGetter: (_, row) => row.submitCount,
        type: "number",
        flex: 1,
        minWidth: 120,
      },
    ]
  }, [t]);

  const fields = useMemo(() => [
    { name: t("common:name"), path: "name", type: EntityFieldTypes.String, required: true },
  ], [t])

  const onCreated = useCallback((entity) => {
    navigate(`./${entity.id}`, { relative: "path" });
  }, [navigate]);

  const onRowClick = useCallback((params, ev) => {
    navigate(`./${params.id}`, { relative: "path" });
  }, [navigate]);

  return (
    <ResponsivePage
      title={t("missionFormRegister:title")}
      maxWidth={config.pageSize.medium}
    >
      {
        !slim ? (
          <Grid item xs={12}>
            <Typography variant="body1" color="textSecondary">{t("missionFormRegister:description")}</Typography>
          </Grid>
        ) : null
      }

      <EntityTable
        tableId="missionForms"
        type="MissionForm"
        columns={columns}
        fields={fields}
        createTitle={t("missionFormRegister:create")}
        emptyStateTitle={t("missionFormRegister:emptyStateTitle")}
        emptyStateDescription={t("missionFormRegister:emptyStateDescription")}
        onRowClick={onRowClick}
        createButton
        onCreated={onCreated}
      />
    </ResponsivePage>
  );
}